import React from "react";

import PasswordResetEmailForm, {
    FormValues,
} from "@/mk2/apps/users/containers/PasswordResetEmail/PasswordResetEmailForm";
import { Props } from "@/mk2/apps/users/containers/PasswordResetEmail/PasswordResetEmailPage";
import {
    PASSR_EMAIL_SEND_EXPLANATION,
    PASSR_EMAIL_TITLE,
    PASSWORD_RESET_WE_SENT_TO_YOUR_EMAIL_INSTRUCTION_HOW_TO_RESET_PASSWORD,
    WE_CANNOT_SEND_YOU_OLD_PASSWORD_BECAUSE_OF_SECURITY_REASON,
} from "@/mk/autogenerated/translations/PasswordResetEmail.bc456d5c7f30770bd893e0d2f71bf0e8";

import styles from "./PasswordResetEmail.mscss";

const initialValues: FormValues = {
    usernameOrEmail: "",
};

interface State {
    submitted: boolean;
}

export default class PasswordResetEmail extends React.Component<Props, State> {
    public state: State = {
        submitted: false,
    };

    public componentDidMount() {
        this.props.onStoreEvent("pwd_reset_req_visited");
    }

    public render() {
        return (
            <div className={styles.PasswordResetEmail}>
                <h1 className={styles.PasswordResetEmail__title}>{PASSR_EMAIL_TITLE}</h1>
                {this.state.submitted ? (
                    <>
                        <p>
                            {PASSWORD_RESET_WE_SENT_TO_YOUR_EMAIL_INSTRUCTION_HOW_TO_RESET_PASSWORD}
                        </p>
                        <p>{WE_CANNOT_SEND_YOU_OLD_PASSWORD_BECAUSE_OF_SECURITY_REASON}</p>
                    </>
                ) : (
                    <>
                        <p className={styles.PasswordResetEmail__subtitle}>
                            {PASSR_EMAIL_SEND_EXPLANATION}
                        </p>
                        <PasswordResetEmailForm
                            initialValues={initialValues}
                            onSave={this.onSave}
                        />
                    </>
                )}
            </div>
        );
    }

    private onSave = (values: FormValues) => {
        const { onSave } = this.props;

        this.setState({
            submitted: true,
        });

        onSave(values.usernameOrEmail, values.captchaToken || "");
    };
}
